import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { uploadImage } from '../../../api/api.global';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const UpdateInfluencerModal = ({ buttonComponent, callback, influencerData }) => {
    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);
    const [influencerDetails, setInfluencerDetails] = useState(null)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getInfluencerDetails = async () => {
        loadingShow();
        let resp = await getApi(urlApi.influencerDetails + influencerData._id);
        loadingHide();
        if (resp.responseCode === 200) {
            setInfluencerDetails(resp.data);
            handleShow();
        } else {
            toast.error(resp?.message);
        }
    }

    function fileOnChange(event) {
        let file = event.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            event.target.value = null;
        } else {
            setFile(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                document.getElementById('pic-preview').src = reader.result;
            }
        }
    }

    async function update() {
        loadingShow();
        let localData = {
            "name": document.getElementById('name').value.trim(),
            "channelName": document.getElementById('channelName').value.trim(),
            "email": document.getElementById('email').value.trim(),
            "phone": document.getElementById('phone').value.trim(),
            "channelLink": document.getElementById('channelLink').value?.trim(),
            "address": document.getElementById('address').value,
            "note": document.getElementById('note').value,
            "genre": document.getElementById('genre').value.trim(),
        }

        let postData = {
            channelName: localData.channelName,
            channelLink: localData.channelLink,
            channelLogo: file ? await uploadImage(file, "advy-influencer-profile-pic") : influencerData.channelLogo,
            note: localData.note
        }

        if (localData?.phone) {
            postData.phone = localData?.phone
        }

        if (localData?.genre) {
            postData.genre = localData?.genre
        }

        if (localData?.name) {
            postData.name = localData?.name
        }

        if (localData?.email) {
            postData.email = localData?.email
        }

        if (localData?.address) {
            postData.address = localData?.address
        }

        if (localData?.note) {
            postData.note = localData?.note
        }

        let resp = await postApi(postData, urlApi.updateInfluencer + influencerData?._id);
        loadingHide();
        if (resp.responseCode === 200) {
            callback?.();
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <>
            <div className='max-w-max' onClick={getInfluencerDetails} >{buttonComponent}</div>

            <Modal show={show} onHide={handleClose} size='xl' backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Update Influencer</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                        <div className="col-span-1">
                            <label htmlFor="channelName" className='text-sm font-semibold mb-1'>Channel Name *</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='channelName' defaultValue={influencerDetails?.channelName} />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="channelLink" className='text-sm font-semibold mb-1'>Channel Link*</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='channelLink' defaultValue={influencerDetails?.channelLink} />
                        </div>
                        <div className="">
                            <label htmlFor="admin-profile-file" className='text-sm font-semibold mb-1'>Channel Logo (Max 5Mb)</label>
                            <input type="file" name="" id="admin-profile-file" onChange={(e) => fileOnChange(e)} className='w-full px-3 py-2 rounded-md border-2 text-sm' accept="image/png, image/gif, image/jpeg" />
                        </div>
                        <img src={influencerDetails?.channelLogo} alt="" id='pic-preview' className='max-h-[200px] max-w-full object-contain rounded-md mx-auto mt-4' />
                        <div className="col-span-1">
                            <label htmlFor="genre" className='text-sm font-semibold mb-1'>Category/Genre*</label>
                            <select name="" id="genre" className='w-full px-3 py-2 rounded-md border-2 text-sm' defaultValue={influencerDetails?.genre}>
                                <option value="" disabled>Category/Genre</option>
                                <option value="Fashion">Fashion</option>
                                <option value="Beauty">Beauty</option>
                                <option value="Fitness">Fitness</option>
                                <option value="Gaming">Gaming</option>
                                <option value="Tech">Tech</option>
                                <option value="Travel">Travel</option>
                                <option value="Food">Food</option>
                                <option value="Lifestyle">Lifestyle</option>
                                <option value="Business">Business</option>
                                <option value="Finance">Finance</option>
                                <option value="Education">Education</option>
                                <option value="Motivation">Motivation</option>
                                <option value="Entertainment">Entertainment</option>
                            </select>
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Name</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='name' defaultValue={influencerDetails?.name} />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="phone" className='text-sm font-semibold mb-1'>Mobile</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' maxLength={10} id='phone' defaultValue={influencerDetails?.phone} />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="email" className='text-sm font-semibold mb-1'>Email</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='email' defaultValue={influencerDetails?.email} />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="address" className='text-sm font-semibold mb-1'>Address</label>
                            <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='address' defaultValue={influencerDetails?.address} ></textarea>
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="note" className='text-sm font-semibold mb-1'>Note</label>
                            <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='note' maxLength={255} defaultValue={influencerDetails?.note} ></textarea>
                        </div>
                    </div>

                    <hr className='my-2' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => update()}>Update</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdateInfluencerModal